<template>
  <section>
    <div class="modal" id="commentsModal" style="z-index: 2">
        <div class="modal-content">
            <div class="formHeader" style="text-align: start">
                <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo" style="max-width: 2em; margin-right: .5em">
                <span style="vertical-align: middle; font-weight: 600">Comentários</span>
            </div>
            <div id="closeButtonDiv">
                <button id="closeButton" v-on:click="closeComments()"><i class="fas fa-window-close fa-lg"></i></button>
            </div>
            <div class="row" v-if="loadingComments" style="display: flex; justify-content: center; padding: 20px">
                <p id="loading"><strong><i class="fas fa-spinner fa-pulse"></i> Carregando comentários...</strong></p>
            </div>
            <div v-if="commentsList.length != 0" class="commentsList">
                <div class="row"
                    style="text-align: start"
                    v-for="el in commentsList" :key="el.id">
                        <p id="commentNomeTecnico">{{el.technician_name}} - {{formatDate(el.created_at)}}</p>
                        <p id="commentMessage">{{el.comment}}</p>
                </div>
            </div>
            <div v-if="commentsList.length == 0 && loadingComments == false" class="row">
                <div class="column" style="flex: 1">
                    <div style="text-align: center; padding: 20px; font-size: 18px">
                        <p><strong>Aviso: </strong> Não há comentários para exibir!</p>
                    </div>
                </div>
            </div>
            <form v-if="!noInsert" id="commentForm" method="post" @submit.prevent>
                <div class="row" v-if="savingComments" style="display: flex; justify-content: center; padding: 20px">
                    <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Salvando comentário...</strong></p>
                </div>
								<div class="column" v-else style="padding: 10px">
										  <textarea class="form-control" type="text" style="width: auto; flex: 1" placeholder="Digite seu comentário..." v-model="newComment"></textarea>
									<div class="row" style="padding: 10px">
                      <button class="btn btn-success" type="submit" id="commentSave" style="width: auto; margin: 3px; line-height: 3" @click="saveComment()"><i class="fas fa-check"></i> Salvar</button>
                      <button class="btn btn-danger" id="closeBtn" style="width: auto; margin: 3px; line-height: 3" @click="closeComments()"><i class="fas fa-window-close fa-fw"></i> Fechar</button>
                	</div>
								</div>

            </form>
        </div>
    </div>
  </section>
</template>

<script>
export default {

    props:['chamadoId','noInsert'],

    data(){
        return {
            newComment: '',
            commentsList: [],
            savingComments: false,
            loadingComments: false
        }
    },

    created(){
        this.getComments()
    },

    methods: {
        getComments(){
            if (this.chamadoId != ""){
                this.loadingComments = true
                axios.get(`/operator/comments/getComments?id=${this.chamadoId}`).then (({data}) => {
                    this.loadingComments = false
                    this.commentsList = data
                })
            }
        },

        saveComment: function(){
            this.savingComments = true

            if (this.chamadoId != '') {
                let newComment = {'at_occurrence_id': this.chamadoId, 'comment': this.newComment}
                axios.post('/operator/comments/create', newComment).then(({data}) => {
                Swal.fire({
                    type: "success",
                    title: "Feito!",
                    text: "Comentário adicionado!"
                }, this.savingComments = false)
                this.newComment = ""
                this.getComments()
                })
            } else {
                Swal.fire({
                    type: "error",
                    title: "Erro!",
                    text: "Para adicionar um comentário, faça a abertura do chamado antes!"
                }, this.savingComments = false);
            }
        },

        closeComments: function(){
            this.$emit("closeComments")
        },

        formatDate(stringDate){
            let p = stringDate.split(/\D/g)
            let date = [p[2],p[1]].join("/")
            let time = stringDate.split(/\s(.+)/g)[1]

            return `${date} ${time}`;
        },
    }
}
</script>

<style scoped>
    #closeButtonDiv{
       position: absolute;
       width: 100%;
       text-align: end;
    }

    #closeButton {
        margin: 6px;
        background-color: rgba(0,0,0,0);
        color: white;
        border: none;
    }

    #closeButton:hover {
        color: #f38630;
    }

    #loading {
        color: rgb(28,134,154);
        font-size: 16px;
        text-align: center
    }
    #saving {
        color: rgb(28,134,154);
        font-size: 16px;
        text-align: center
    }

    .container {
         overflow-y: auto;
         overflow-x: hidden;
         height: 70vh
    }

    .noteHide {
        display: none;
    }

    .row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        align-items: center;
    }

    .column {
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1;
				height:200px;
    }

    .input-group-prepend {
        margin: .1em;
        padding: .1em;
    }

    .modal {
      display: block; /* Hidden by default */
      position: absolute; /* Stay in place */
      z-index: 1; /* Sit on top */
      left: 0;
      top: 0;
      width: 100%; /* Full width */
      height: 100%; /* Full height */
      overflow-y: auto; /* Enable scroll if needed */
      background-color: rgb(0,0,0); /* Fallback color */
      background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }

    .modal-content {
      background-color: #fefefe;
      margin: 2% auto; /* 15% from the top and centered */
      padding: 20px;
      border: 1px solid #888;
      width: 90%; /* Could be more or less, depending on screen size */
      padding: 0
    }

    .commentsList {
				margin: 0 0 1% 2%;
				padding: 10px;
        min-height: 10em;
        max-height: 20em;
        overflow-y: scroll;
    }

    .close {
        color: #aaa;
        float: right;
        font-size: 28px;
        font-weight: bold;
    }

    .close:hover,
    .close:focus {
      color: black;
      text-decoration: none;
      cursor: pointer;
    }

    #cardChamado {
    border: 1px solid lightgray;
    flex-grow: 1;
    }

    .formHeader {
        background-color: rgb(28,134,154);
        border-top: 3px solid #f38630;
        color: white;
        padding: 0.2em;
    }

    #formBody {
        text-align: -webkit-center;
    }

    #diretoriaCheckbox {
        display: inline-block;
    }

    #commentNomeTecnico {
        font-weight: 700;
        color: darkgreen;
        background-color: #c0eaca;
        border-radius: 20px;
        z-index: 1;
        padding: 5px;

    }

    #commentMessage {
        max-height: 6em;
        overflow-y: auto;
        background-color: #d5fdd5;
        width: 100vw;
        margin-top: 5px;
        border-radius: 20px;
        padding: 10px;
    }

    #openComments {
        background-color: rgb(28,134,154);
        z-index: 0;
        height: 6em;
        width: 6em;
        font-size: smaller;
        padding: 1px;
    }
</style>
